/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillListVo } from './BillListVo';
import {
    BillListVoFromJSON,
    BillListVoFromJSONTyped,
    BillListVoToJSON,
    BillListVoToJSONTyped,
} from './BillListVo';

/**
 * 
 * @export
 * @interface ResponseBillListVo
 */
export interface ResponseBillListVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseBillListVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseBillListVo
     */
    message?: string;
    /**
     * 
     * @type {BillListVo}
     * @memberof ResponseBillListVo
     */
    data?: BillListVo;
}

/**
 * Check if a given object implements the ResponseBillListVo interface.
 */
export function instanceOfResponseBillListVo(value: object): value is ResponseBillListVo {
    return true;
}

export function ResponseBillListVoFromJSON(json: any): ResponseBillListVo {
    return ResponseBillListVoFromJSONTyped(json, false);
}

export function ResponseBillListVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBillListVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : BillListVoFromJSON(json['data']),
    };
}

export function ResponseBillListVoToJSON(json: any): ResponseBillListVo {
    return ResponseBillListVoToJSONTyped(json, false);
}

export function ResponseBillListVoToJSONTyped(value?: ResponseBillListVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': BillListVoToJSON(value['data']),
    };
}

